export const config = {
  REACT_APP_API_BASE_URL: `${process.env.REACT_APP_API_BASE_URL}`,
  REACT_APP_GOOGLE_CLIENT_ID: `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`,
  REACT_APP_ANALYTICS_ID: `${process.env.REACT_APP_ANALYTICS_ID}`
};

export const getEnv = () => {
  const host = window.location.hostname;

  if (host.includes('brendathebot.com')) {
    return 'prod';
  }
  return 'dev';
};